module.exports = ".graph-container {\n  width: 100%;\n  height: 100%;\n  display: block; }\n"